module.exports = __webpack_public_path__ + "img/tail_dark_grey.a514303d.svg";